import { Briefcase, Handshake, LayoutDashboard, Send, Settings, Users, type LucideIcon } from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  /** Match nested routes (default true); the dashboard is exact. */
  end?: boolean;
}

/** Primary navigation, in sidebar order. Pages are registered in app/router.tsx. */
export const NAV_ITEMS: NavItem[] = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/positions', label: 'Positions', icon: Briefcase },
  { to: '/candidates', label: 'Candidates', icon: Users },
  { to: '/submissions', label: 'Submissions', icon: Send },
  { to: '/partners', label: 'Partners', icon: Handshake },
  { to: '/settings', label: 'Settings', icon: Settings },
];
